const UNIVERSAL = {

  BASEURL: "https://crm-backend-236970479379.asia-south1.run.app/",

  // BASEURL: "http://localhost:7004/",
};

export default UNIVERSAL;
